import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Demo2Nav from './Demo2Nav';
import { MOBILE_TABS } from '../demo2Routes';

export default function Demo2MobileLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const activeKey = MOBILE_TABS.find(t => path.startsWith(t.path))?.key ?? '';

    return (
        <>
            <Demo2Nav />
            <div className="sian sian-mobile-stage">
                <div className="phone-frame">
                    <div className="phone-notch" />
                    <div className="phone-screen">
                        <div className="m-statusbar">
                            <span>9:41</span>
                            <span className="m-statusbar-icons"><i className="ri-signal-wifi-line" /><i className="ri-battery-2-line" /></span>
                        </div>
                        <Outlet />
                        <div className="m-tabbar">
                            {MOBILE_TABS.map(t => (
                                <a
                                    key={t.key}
                                    className={`m-tab${t.key === activeKey ? ' active' : ''}`}
                                    onClick={() => navigate(t.path)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <span className="m-tab-ico-wrap"><i className={`m-tab-ico ${t.riIco}`} /></span>
                                    <span className="m-tab-lbl">{t.txt}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
